/** Social proof bar: copy deck §2. Honest pre-launch treatment: no fake
 * logos or stats. Build-in-public line + capability chips, on a light band
 * with hairline rules. */
const CHIPS = [
  'Sends via Google Workspace OAuth',
  'SPF / DKIM / DMARC checks',
  'Built-in warmup',
  'Auto-pause on bounce spikes',
  'CAN-SPAM & GDPR unsubscribe',
];

export function SocialProof() {
  return (
    <div className="border-y border-slate-200 bg-white px-4 py-10 sm:px-6">
      <div className="mx-auto grid max-w-6xl items-center gap-8 lg:grid-cols-12">
        <p className="text-slate-600 lg:col-span-5">
          Built by a founder who got tired of watching good domains land in
          spam. RevBase is new, so you&rsquo;ll be one of the first to send on it.
          Here&rsquo;s exactly what it does and why.
        </p>
        <div className="flex flex-wrap gap-2 lg:col-span-7 lg:justify-end">
          {CHIPS.map((chip) => (
            <span
              key={chip}
              className="rounded-lg border border-slate-200 bg-slate-50 px-3 py-1.5 text-xs font-medium text-slate-600"
            >
              {chip}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
